//polyfills
import 'core-js/stable';
import 'regenerator-runtime/runtime';

window.MediaError = require("./polyfills/media_error");
window.HTMLVideoElement = require("./polyfills/html_video_element");
require("./polyfills/get_computed_style");

// utility
window.Experiment        = require("./shared/experiment").default;
window.FlashVersion      = require("javascripts/flash_version").default;
window.Timing            = require("./shared/timing").default;
window.PlayerEnvironment = require("./shared/player_environment").default;
window.Uap               = require("./shared/uap/uap").default;
window.Topic             = require("./shared/topic").default;
window.PageSource        = require("./shared/page_source").default;
window.UrlUtils          = require("./shared/url_utils").default;
window.WindowAdapter     = require("./shared/window_adapter").default;
window.LocationAdapter   = require("./shared/location_adapter").default;
window.ConnectionUtil    = require("./shared/connection_util").default;
window.Env               = require("./shared/env").default;
window.ConnectionAdapter = require("./shared/connection_adapter").default;

// recommendation
window.RecoEvent                  = require("./shared/components/recommendation/reco_event").RecoEvent;
window.LateralEvent               = require("./shared/components/recommendation/lateral_event").LateralEvent;
window.LateralEpisodicCachedEvent = require("./shared/components/recommendation/lateral_episodic_cached_event").LateralEpisodicCachedEvent;
window.LarvaCachedEvent           = require("./shared/components/recommendation/larva_cached_event").LarvaCachedEvent;
window.RecommenderPicker          = require("./shared/components/recommendation/recommender_picker").RecommenderPicker;
window.SidebarRelatedVideos       = require("./shared/components/recommendation/sidebar_related_videos").SidebarRelatedVideos;
window.PlayerRelatedVideos        = require("./shared/components/recommendation/player_related_videos").PlayerRelatedVideos;
window.SimilarFilm                = require("./shared/components/recommendation/similar_film").default;
window.SectionsByAjax             = require("./shared/components/sections_by_ajax").default;
window.LivestreamingRelated       = require("./shared/components/livestreaming_related").default;
window.LivestreamingRelatedEventStream = require("./shared/components/livestreaming_related_event_stream").default;

// plenty tracker
window.RecommendedForYouTracker     = require("./shared/components/plenty_tracker/recommended_for_you_tracker").RecommendedForYouTracker;
window.CollectionsListTracker       = require("./desktop/components/plenty_tracker/collections_list_tracker").default;
window.HomepageTracker              = require("./shared/components/plenty_tracker/homepage_tracker").default;
window.LivestreamingPresenceTracker = require("./shared/components/plenty_tracker/livestreaming_presence_tracker").default;
window.CategoryPageTracker          = require("./shared/components/plenty_tracker/category_page_tracker").default;
window.HomepageFeaturedTrending     = require("./shared/components/plenty_tracker/homepage_featured_trending").default;
window.SearchTracker                = require("./shared/components/plenty_tracker/search_tracker").default;

// video_player
window.Previewer = require("./shared/components/video_player/previewer").default;

// playback
window.PlaybackBaseLoader = require("./shared/playback_base_loader").default;

// others
window.Page = require("./shared/components/page").default;
window.VideoShowMore = require('./shared/video_show_more').default;
window.IsUserSignedIn = require('./shared/is_user_signed_in').default;
